import {
  Modal,
  ModalBody,
  ModalInput,
  ModalInputWrapper,
  ModalInputRadio,
  modalConnect,
  ModalFooter,
  ModalButton,
} from "@modal";

import {
  ceModalUpdateState,
} from "@js/actions/studio/modals.js";

import {
  ceDismissSaveCustomRowModal,
  ceSubmitSaveCustomRowModal,
} from "@js/actions/studio/campaign_content_section/custom_rows.js";

export default modalConnect((props) => {
  return (
    <Modal
      title={t("phrases.save_custom_row")}
      onCancel={() => props.dispatch(ceDismissSaveCustomRowModal(props.connector))}
      onSave={() => props.dispatch(ceSubmitSaveCustomRowModal(props.connector))}
      saveText={t("buttons." + ( props.offer_overwrite ? "overwrite" : "save" ))}
      dangerous={props.offer_overwrite}
      loading={props.save_in_progress}
    >
      <ModalInput
        type="text"
        onChange={(e) =>
          props.dispatch(ceModalUpdateState({
            name: e.target.value,
            offer_overwrite: false,
            error_message: null,
          }))
        }
        value={props.name || ""}
        error={props.error_message}
        onEnter={() => props.dispatch(ceSubmitSaveCustomRowModal(props.connector))}
        label={t("placeholders.enter_name_for_custom_row")}
        autoFocus
      />
    </Modal>
  );
});
